module.exports = __webpack_public_path__ + "img/HongKongTrust6.2e92f29f.png";